import { Injectable } from '@angular/core';
import { ICmsCoreIntegrationAbstractService } from './icms-core-integration-abstract.service';
import { NICmsContentComponent } from '@icms/core/content/interfaces/icms-content-component.interfaces';

@Injectable({ providedIn: 'root' })
export class ICmsCoreIntegrationComponentService extends ICmsCoreIntegrationAbstractService<NICmsContentComponent.IEditableComponent> {}
